import { P2GBox, P2GText } from '@parcel2go/core-ui';
import { Suspense } from 'react';

const DesktopTitledLayout = ({
  children,
  title,
  actions
}: {
  children: React.ReactNode;
  title: string;
  actions?: React.ReactNode;
}) => (
  <Suspense>
    <P2GBox sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {(title || actions) && (
        <P2GBox display="flex" justifyContent="space-between" alignItems="center">
          {title && <P2GText variant="h2">{title}</P2GText>}
          {actions && (
            <P2GBox display="flex" gap={1} alignItems="center">
              {actions}
            </P2GBox>
          )}
        </P2GBox>
      )}
      {children}
    </P2GBox>
  </Suspense>
);

export default DesktopTitledLayout;
